import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';

const Editwallet = () => {
    const params = useParams();
    const [wallet, setwallet] = useState(null);
    const [walletForm, setwalletForm] = useState({
        name: '',
        address: '',
        wallet_type: '',
        display_area: '',
        coin_image_url: ''
    });
    const [coinImage, setCoinImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    
    const { isLoading: isLoadingwallets, refetch: getwallets } = useQuery(
        "edit-wallet",
        async () => {
          return await apiClient.get(`/api/edit-wallet/${params.id}`);
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setwallet(res.data.wallet);
                setwalletForm({
                    name : res.data.wallet.coin_name,
                    address : res.data.wallet.address,
                    wallet_type : res.data.wallet.wallet_type,
                    display_area : res.data.wallet.display_area,
                    coin_image_url : res.data.wallet.coin_image || ''
                });
                // Set initial image preview if coin_image exists
                if (res.data.wallet.coin_image) {
                    setImagePreview(res.data.wallet.coin_image);
                }
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      
    const dispatch = useDispatch();
    
    const [error, setErros] = useState('');
    

    const onChange = (e) =>
    setwalletForm({ ...walletForm, [e.target.name]: e.target.value });

    const onImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCoinImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const { isLoading: isSendingRequest, mutate: postwallet } = useMutation(

        async () => {
          const formData = new FormData();
          formData.append('coin_name', walletForm.name);
          formData.append('address', walletForm.address);
          formData.append('wallet_type', walletForm.wallet_type);
          formData.append('display_area', walletForm.display_area);
          
          // Add image file if selected, otherwise send the URL
          if (coinImage) {
            formData.append('coin_image', coinImage);
          } else if (walletForm.coin_image_url) {
            formData.append('coin_image_url', walletForm.coin_image_url);
          }

          return await apiClient.post(`/api/update-wallet/${params.id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = () =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postwallet();
      } 

      useEffect(() => {
        getwallets();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
        {wallet !== null && 

        <Grid container px={2} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <Typography mt={4} sx={{ fontWeight: 'bold', fontSize: 24, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                        EDIT WALLET ADDRESS
                    </Typography>
                    <Typography  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        Fill the form below to edit wallet address
                    </Typography>

                    <FormControl  fullWidth={true} sx={{ m: 1, minWidth: 50, marginBottom: '10px' }}>
                      <InputLabel htmlFor="display_area">Display Area</InputLabel>
                      <Select
                          onChange={onChange}
                          value={walletForm.display_area || ''}
                          labelId="display_area"
                          name="display_area"
                          id="display_area"
                          label={`Display Area`}
                          >
                          <MenuItem value=''>
                            Select where to display this payment method
                            </MenuItem> 
                          <MenuItem value='withdrawals'>
                          withdrawals
                          </MenuItem> 
                          <MenuItem value='payments'>
                          deposits/payments
                          </MenuItem> 
                      </Select>                        
                    </FormControl>

                    <FormControl  fullWidth={true} sx={{ m: 1, minWidth: 50, marginBottom: '10px' }}>
                      <InputLabel htmlFor="wallet_type">Wallet Type</InputLabel>
                      <Select
                          onChange={onChange}
                          value={walletForm.wallet_type || ''}
                          labelId="wallet_type"
                          name="wallet_type"
                          id="wallet_type"
                          label={`Wallet Type`}
                          >
                          <MenuItem value=''>
                            Select Option
                            </MenuItem> 
                          <MenuItem value='bank'>
                          Bank
                          </MenuItem> 
                          <MenuItem value='Crypto'>
                          Crypto
                          </MenuItem> 
                      </Select>                        
                    </FormControl>

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="Wallet Name">wallet Name/Bank Name</InputLabel>
                            {(error !== '' && error.name) ?
                            <OutlinedInput
                            error
                            onChange={onChange}
                            value={walletForm.name}
                            id="name"
                            name="name"
                            type={'text'}
                            label="wallet Name/Bank Name"
                            helperText={error.name}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            value={walletForm.name}
                            id="name"
                            name="name"
                            type={'text'}
                            label="wallet Name/Bank Name"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.name}
                            </Typography>
                            
                        </FormControl>

                        

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="address">Address/Bank Account Details</InputLabel>
                            {(error !== '' && error.address) ?

                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="address"
                            value={walletForm.address}
                            type={'text'}
                            name="address"
                            label="Address/Bank Account Details"
                            helperText={error.address}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            value={walletForm.address}
                            id="address"
                            type={'text'}
                            name="address"
                            label="Address/Bank Account Details"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.address}
                            </Typography>
                            
                        </FormControl>

                        {/* Coin Image Section */}
                        <Divider sx={{ my: 2 }} />
                        <Typography sx={{ fontWeight: 'bold', fontSize: 18, mb: 2 }} variant="h6">
                            Coin/Payment Method Image
                        </Typography>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Upload a custom image for this payment method. This is useful for coins like USDT TRC20 
                            that don't have dynamic images. The uploaded image will be used as a fallback.
                        </Alert>

                        {/* Image Preview */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <Avatar 
                                src={imagePreview || `https://assets.coincap.io/assets/icons/${walletForm.name?.toLowerCase()}@2x.png`}
                                sx={{ width: 64, height: 64 }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = '';
                                }}
                            >
                                <ImageIcon />
                            </Avatar>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Current Image Preview
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {imagePreview ? 'Custom image set' : 'Using default (may not exist for all coins)'}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Image Upload */}
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <Typography sx={{ mb: 1, fontSize: 14 }} variant="subtitle2">
                                Upload New Image
                            </Typography>
                            <OutlinedInput
                                onChange={onImageChange}
                                accept="image/*"
                                id="coin_image"
                                type="file"
                                name="coin_image"
                            />
                        </FormControl>

                        {/* OR Image URL */}
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="coin_image_url">Or Enter Image URL</InputLabel>
                            <OutlinedInput
                                onChange={onChange}
                                value={walletForm.coin_image_url || ''}
                                id="coin_image_url"
                                type="text"
                                name="coin_image_url"
                                label="Or Enter Image URL"
                                placeholder="https://example.com/coin-image.png"
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                You can paste a direct URL to an image instead of uploading
                            </Typography>
                        </FormControl>

                        
                    </CardContent>   

                    <CardActions>
                        <Button onClick={onSubmit} fullWidth={true} size="large" color="primary" variant="contained"> {isSendingRequest? 'Updating...' : 'Update wallet'}</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
        }
    </div>
  )
}

export default Editwallet
